const BasicInfo = () => import('@/views/BasicInfo')

export default [
  {
    path: '/basicInfo',
    component: BasicInfo,
    meta: { requireAuth: true }
  }
]
